import { toast } from "react-toastify";
import api from "shared/api";
import { BaseApiService } from "shared/api";
import { REQUEST_TYPES } from "shared/config";
import { withToast } from "shared/utils";

class RequestService extends BaseApiService {
  async submitRequest(userRole, requestId, options) {
    return await withToast(
      () =>
        api.post(this.ENDPOINTS.request.shared.submit, {
          user_role: userRole,
          application_id: requestId,
        }),
      options
    );
  }
  async updateRequest(requestNumber, payload, options) {
    return await withToast(
      () =>
        api.post(
          `${this.ENDPOINTS.request.shared.update}/${requestNumber}`,
          payload
        ),
      options
    ).then((response) => response.data.data);
  }
  async acceptRequest(userRole, requestId, options) {
    await withToast(
      () =>
        api.post(this.ENDPOINTS.request.shared.accept, {
          user_role: userRole,
          application_id: requestId,
        }),
      options
    );
  }
  async rejectRequest(userRole, requestId, reasonOfRejection) {
    return await withToast(() =>
      api.post(this.ENDPOINTS.request.shared.reject, {
        user_role: userRole,
        application_id: requestId,
        comment: reasonOfRejection,
      })
    );
  }
  async withdrawRequest(userRole, requestId, options) {
    return await withToast(
      () =>
        api.post(this.ENDPOINTS.request.shared.cancel, {
          user_role: userRole,
          application_id: requestId,
        }),
      options
    );
  }
  async updateCardRequest(payload) {
    return await withToast(
      () => api.post(this.ENDPOINTS.request.card.update, payload),
      {
        onSuccess: "Request has been successfully updated",
      }
    ).then((response) => response.data.data);
  }

  async submitCardRequest(requestType, requestId, userRole) {
    if (requestType === REQUEST_TYPES.EUROCARD) {
      return await withToast(
        () =>
          api.post(this.ENDPOINTS.request.shared.submit, {
            user_role: userRole,
            application_id: requestId,
          }),
        {
          onSuccess: "Request has been successfully submitted",
        }
      );
    } else {
      return await withToast(
        () => api.post(`${this.ENDPOINTS.request.shared.submit}/${requestId}`),
        {
          onSuccess: "Request has been successfully submitted",
        }
      );
    }
  }

  async setOnHold(payload) {
    return await withToast(() =>
      api.post(this.ENDPOINTS.accounts_payable.on_hold, payload)
    ).then((response) => response.data.data);
  }
  async deleteOnHold(requestId) {
    return await withToast(() =>
      api.delete(`${this.ENDPOINTS.accounts_payable.on_hold}/${requestId}`)
    ).then((response) => response.data.data);
  }

  async confirmSapExport(id) {
    return await withToast(
      () =>
        api
          .post("/api/accounts-payable/sap-exports/confirm-sap-export", {
            sap_export_id: id,
          })
          .then((response) => {
            toast.success(response.data.message, {
              theme: "colored",
            });
            return response.data.data;
          }),
      {
        catchError: false,
      }
    );
  }

  async generateSapExport(countryCode) {
    return await withToast(
      () =>
        api
          .post("/api/accounts-payable/applications/generate-sap-export", {
            country_code: countryCode,
          })
          .then((response) => {
            toast.success(response.data.message, {
              theme: "colored",
            });
            window.location.href = response?.data?.data.download_link;
          }),
      {
        catchError: false,
      }
    );
  }
}

export const requestService = new RequestService();
